import { atom } from 'recoil'

export const deadShrimpDateFilterState = atom<Date>({
  key: 'deadShrimpDateFilterState',
  default: new Date(),
})

export const deadShrimpDateTableFilterState = atom<{ setDate: Date | undefined; endDate: Date | undefined }>({
  key: 'deadShrimpDateTableFilterState',
  default: {
    setDate: undefined,
    endDate: undefined,
  },
})

export const selectedDeadShrimpIdState = atom<number | undefined>({
  key: 'selectedDeadShrimpIdState',
  default: undefined
})
